module.exports = __webpack_public_path__ + "static/6013-San-Bernard-Plan-768x1123-4f31e4ce2fdba727e95aacdbe8e2412b.jpg";